// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4o-0";
export var eligibilityCardNotEligible = "_4o-1";